var map = {
	"./breakfast_1_1680.png": 8051,
	"./breakfast_1_420.png": 7250,
	"./breakfast_1_980.png": 8640,
	"./breakfast_2_1680.png": 495,
	"./breakfast_2_420.png": 3143,
	"./breakfast_2_980.png": 2349,
	"./breakfast_3_1680.png": 3092,
	"./breakfast_3_420.png": 6528,
	"./breakfast_3_980.png": 7373,
	"./breakfast_4_1680.png": 1621,
	"./breakfast_4_420.png": 543,
	"./breakfast_4_980.png": 8140,
	"./breakfast_5_1680.png": 1760,
	"./breakfast_5_420.png": 6670,
	"./breakfast_5_980.png": 8404,
	"./breakfast_6_1680.png": 910,
	"./breakfast_6_420.png": 1803,
	"./breakfast_6_980.png": 7147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3926;